import { formatDate } from '@if/core/utils'
import EditIcon from '@mui/icons-material/Edit'
import { Avatar, Box, Button, Divider, Paper, Stack, Typography } from '@mui/material'
import { useGetPersonById } from '@src/api/person-api'
import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import PageLoader from '@src/components/Loader/PageLoader'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
interface Props {
  id: string
}
const PersonDetailsPage = ({ id }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [data, isFetching] = useGetPersonById(id)

  return isFetching ? (
    <PageLoader />
  ) : (
    <>
      <PageHeader
        title={t('menus.personDetails')}
        breadcrumbs={{
          path: [
            { href: '/people', label: t('breadcrumbs.people') },
            { href: '/people/' + id, label: data ? data.fullName : '' },
          ],
        }}
      />
      <PageContainer>
        <Stack direction="row" sx={{ width: '100%', height: '100%' }} spacing={1} marginTop={1}>
          <Stack
            direction="column"
            sx={{
              padding: 0,
              alignItems: 'center',
              width: '20%',
            }}
          >
            <Paper
              sx={{
                padding: 1,
                width: '100%',
              }}
              elevation={3}
            >
              <Box display="flex" alignItems="center" justifyContent="center" margin={1}>
                <Avatar
                  alt={data ? data.fullName : ''}
                  sx={{
                    width: 168,
                    height: 168,
                  }}
                >
                  {data ? data.fullName[0] : ''}
                </Avatar>
              </Box>
              <Box display="flex" alignItems="center" justifyContent="center" margin={1}>
                <Typography variant="h3"> {data ? data.fullName : ''}</Typography>
              </Box>
              <Box display="flex" alignItems="center" justifyContent="center" margin={1}>
                <Typography> {t('person.developer')}</Typography>
              </Box>
              <Divider></Divider>
              <Box display="flex" justifyContent="flex-start" padding={1} flexDirection="column" margin={1}>
                <Typography variant="h6">Status</Typography>
                <Typography>{data ? (data.endDate == null ? 'Actif' : 'Non Actif') : ''}</Typography>
              </Box>
              <Box display="flex" justifyContent="flex-start" padding={1} flexDirection="column" margin={1}>
                <Typography variant="h6">{t('person.bambooId')}</Typography>
                <Typography>{data ? data.bambooId : ''}</Typography>
              </Box>
              <Box display="flex" justifyContent="flex-start" padding={1} flexDirection="column" margin={1}>
                <Typography variant="h6">{t('person.team')}</Typography>
                <Typography>{data?.team}</Typography>
              </Box>
            </Paper>
          </Stack>

          <Stack
            direction="row"
            sx={{
              padding: 0,
              width: '80%',
            }}
          >
            <Paper
              sx={{
                width: '100%',
              }}
              elevation={3}
            >
              <Box display="flex" justifyContent="space-between" padding={1}>
                <Typography variant="h4">Basic Information</Typography>
                <Stack direction="row-reverse" sx={{ paddingBottom: 1 }} spacing={1}>
                  <Button
                    variant="text"
                    color="inherit"
                    onClick={() => {
                      navigate('/people/' + id + '/Edit')
                    }}
                    startIcon={<EditIcon />}
                  >
                    {t('common.edit')}
                  </Button>
                </Stack>
              </Box>
              <Box display="flex" justifyContent="flex-start" padding={1} flexDirection="column">
                <Typography variant="h6">{t('person.startDate')}</Typography>
                <Typography>{data ? formatDate(data.startDate) : ''}</Typography>
              </Box>
              <Box display="flex" justifyContent="flex-start" padding={1} flexDirection="column">
                <Typography variant="h6">{t('person.endDate')}</Typography>
                <Typography>{data ? formatDate(data.endDate) : ''}</Typography>
              </Box>
              <Box display="flex" justifyContent="flex-start" padding={1} flexDirection="column">
                <Typography variant="h6">{t('person.email')}</Typography>
                <Typography>{data ? data.email : ''}</Typography>
              </Box>
            </Paper>
          </Stack>
        </Stack>
      </PageContainer>
    </>
  )
}

export default PersonDetailsPage
